import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RoadmapRoadmapVisualisationInitiativeBoxIndexComponent extends Component {
  @service initiativeSlideover;

  @action
  openSlideover() {
    this.initiativeSlideover.open(this.args.initiative.id);
  }
}
